// orphaned-ticket-recovery-evidence.ts
//
// Split out of orphaned-ticket-reconciler.ts (D12, phase 05 B1 — that file
// sat at the 198-line ceiling). Owns building the human-readable `evidence`
// string for each of the 3 orphan outcomes (supervisor_crash/binding_corrupt/
// worker_orphaned) — pure string-building, no I/O, no decision logic (that
// stays in the reconciler's own detectOrphanedInProgressTickets).
//
// Req 9 (phase 05, NEW-3): `supervisor_crash` (no binding file at all) used
// to always read as an evidence-free "có thể chưa spawn, hoặc đã spawn rồi
// bị dọn qua 'autopilot unlock'" — no signal to pick one. When
// `autopilot unlock` HAS a marker newer than this ticket's most recent
// `attempt_started`, the evidence names that fact + the pgid/timestamp
// instead of staying neutral.
//
// Review H1 fix: `markerIsNewerThanAttempt` is a caller-computed boolean
// (reconciler.ts owns comparing `unlockMarker.released_at` against this
// ticket's own most recent `attempt_started`, and matching `ticket` when the
// marker has one) — this function stays pure string-building, no timestamp
// logic of its own (matches this module's own "no decision logic" header).
export function noBindingSupervisorCrashEvidence(
  ticketId: string,
  unlockMarker?: { killed_worker_pgid: number; released_at: string },
  markerIsNewerThanAttempt = false,
): string {
  if (unlockMarker && markerIsNewerThanAttempt) {
    return (
      `ticket ${ticketId} còn "in_progress" nhưng không có binding file cho attempt hiện tại — ` +
      `worker đã bị 'autopilot unlock' kill (pgid ${unlockMarker.killed_worker_pgid} lúc ` +
      `${unlockMarker.released_at}); không còn writer sống.`
    );
  }
  return (
    `ticket ${ticketId} còn "in_progress" nhưng không có binding file cho attempt ` +
    "hiện tại — không rõ worker có kịp spawn hay không (có thể chưa spawn, hoặc đã " +
    "spawn rồi bị dọn qua 'autopilot unlock'); không còn writer sống."
  );
}

export function bindingCorruptEvidence(ticketId: string): string {
  return (
    `ticket ${ticketId} còn "in_progress", binding file tồn tại nhưng không đọc được ` +
    "(JSON hỏng hoặc thiếu expires_at) — KHÔNG tự reclaim, cần điều tra thủ công."
  );
}

export function bindingExpiresAtUnparseableEvidence(ticketId: string, expiresAt: string): string {
  return (
    `ticket ${ticketId} còn "in_progress", binding có expires_at="${expiresAt}" ` +
    "KHÔNG parse được thành thời điểm — liveness không xác định, KHÔNG tự reclaim."
  );
}

export function workerOrphanedEvidence(
  ticketId: string,
  expiresAt: string,
  nowIso: string,
): string {
  return (
    `ticket ${ticketId} còn "in_progress", binding lease đã hết hạn ` +
    `(expires_at=${expiresAt}, now=${nowIso}) — không còn writer sống.`
  );
}
